import Vue from 'vue'
import VueRouter from 'vue-router'

import AdminLTE from '../AdminLTE.vue'
import Assistant from '../Assistant.vue'

import Loading from '../Loading.vue'
import Login from '../Login.vue'
import Logout from '../Logout.vue'
import Unauthorized from '../Unauthorized.vue'

import Profile from '../modules/Profile.vue'

import Clients from '../modules/client/Clients.vue'

import Labels from '../modules/global/label/Labels.vue'


import AssistantConfig from '../modules/system/AssistantConfig.vue'
import AssistantEdit from '../modules/system/AssistantEdit.vue'
import AssistantActionEdit from '../modules/system/AssistantActionEdit.vue'
import Users from '../modules/user/Users.vue'
import Ticket from '../modules/ticket/Ticket.vue'
import Tickets from '../modules/ticket/Tickets.vue'

import Chartjs from '../modules/adminlte/Chartjs.vue'
import Chat from '../modules/adminlte/Chat.vue'
import Dashboard1 from '../modules/adminlte/Dashboard1.vue'
import Test from '../modules/adminlte/Test.vue'

import Shippings from '../modules/logistic/Shippings.vue'
import AttendOrders from '../modules/logistic/AttendOrders.vue'
import Attend from '../modules/logistic/Attend.vue'
import Stores from '../modules/logistic/Stores.vue'
import LogisticsCenter from '../modules/logistic/LogisticsCenter.vue'

import Inventories from '../modules/logistic/Inventories.vue'
import Inventory from '../modules/logistic/Inventory.vue'
import InventoryTemplate from '../modules/logistic/InventoryTemplate.vue'

import InventoryTemplatesComponent from '../components/InventoryTemplatesComponent.vue'
import InventoryRun from '../modules/logistic/InventoryRun.vue'

import GeneratedSubscriptions from '../modules/genesys/GeneratedSubscriptions.vue'
import Sales from '../modules/genesys/Sales.vue'

import Products from '../modules/production/Products.vue'

import Journals from '../modules/accountancy/Journals.vue'
import Journal from '../modules/accountancy/Journal.vue'
import Payments from '../modules/accountancy/Payments.vue'

import Subscriptions from '../modules/sale/Subscriptions.vue'
import Subscription from '../modules/sale/Subscription.vue'
import SubscriptionGenerate from '../modules/subscription/SubscriptionGenerate.vue'
import SubscriptionInvoices from '../modules/subscription/SubscriptionInvoices.vue'
import LegalDocuments from '../modules/sale/LegalDocuments.vue'
import Churchs from '../modules/sale/Churchs.vue'
import Printouts from '../modules/sale/Printouts.vue'
import Orders from '../modules/sale/Orders.vue'
import BookstoreBilling from '../modules/sale/BookstoreBilling.vue'

import TeamOrders from '../modules/team/TeamOrders.vue'
import Consignments from '../modules/team/Consignments.vue'
import Teams from '../modules/team/Teams.vue'
import Team from '../modules/team/Team.vue'

import JumpsellerOrders from '../modules/jumpseller/jumpsellerOrders.vue'

import StatisticSubscription from '../modules/statistic/Subscription.vue'
import StatisticSubscriptionChurch from '../modules/statistic/SubscriptionChurch.vue'

Vue.use(VueRouter)

const routes =
	[
		{
			path: '/',
			name: 'AdminLTE',
			component: AdminLTE,
			children: [
				{ path: '/journals', name: 'Journals', component: Journals, meta: { menu_id: 13 } },
				{ path: '/journal', name: 'Journal', component: Journal, meta: { menu_id: 14 } },
				{ path: '/clients', name: 'Clients', component: Clients, meta: { menu_id: 21 } },
				{ path: '/chartjs', name: 'Chartjs', component: Chartjs, meta: { menu_id: 1 } },
				{ path: '/chat', name: 'Chat', component: Chat, meta: { menu_id: 1 } },
				{ path: '/dashboard1', name: 'Dashboard1', component: Dashboard1, meta: { menu_id: 1 } },
				{ path: '/labels', name: 'Labels', component: Labels, meta: { menu_id: 10 } },
				{ path: '/products', name: 'Products', component: Products, meta: { menu_id: 18 } },
				{ path: '/shippings', name: 'Shippings', component: Shippings, meta: { menu_id: 16 } },
				{ path: '/attendOrders', name: 'AttendOrders', component: AttendOrders, meta: { menu_id: 11 } },
				{ path: '/attend', name: 'Attend', component: Attend, meta: { menu_id: 11 } },
				{ path: '/logisticsCenter', name: 'LogisticsCenter', component: LogisticsCenter, meta: { menu_id: 31 } },
				{ path: '/stores', name: 'Stores', component: Stores, meta: { menu_id: 30 } },
				{ path: '/inventories', name: 'Inventories', component: Inventories, meta: { menu_id: 32 } },
				{ path: '/inventory/:id', name: 'Inventory', component: Inventory, props: true, meta: {} },
				{ path: '/inventoryTemplate/:id', name: 'InventoryTemplate', component: InventoryTemplate, props: true, meta: {} },
				{ path: '/legalDocuments', name: 'LegalDocuments', component: LegalDocuments, meta: { menu_id: 22 } },
				{ path: '/teamOrders', name: 'TeamOrders', component: TeamOrders, meta: { menu_id: 27 } },
				{ path: '/consignments', name: 'Consignments', component: Consignments, meta: { menu_id: 28 } },
				{ path: '/teams', name: 'Teams', component: Teams, meta: { menu_id: 26 } },
				{ path: '/team/:id', name: 'Team', component: Team, props: true, meta: {} },
				{ path: '/printouts', name: 'Printouts', component: Printouts, meta: {} },
				{ path: '/subscriptions', name: 'Subscriptions', component: Subscriptions, meta: { menu_id: 23 } },
				{ path: '/subscriptionGenerate/:year', name: 'SubscriptionGenerate', component: SubscriptionGenerate, meta: {}, props: true },
				{ path: '/subscriptionInvoices/:year', name: 'SubscriptionInvoices', component: SubscriptionInvoices, meta: {}, props: true },
				{ path: '/statistic/subscription/:year', name: 'StatisticSubscription', component: StatisticSubscription, props: true },
				{ path: '/statistic/subscription/:year/church/:id', name: 'StatisticSubscriptionChurch', component: StatisticSubscriptionChurch, props: true },
				{ path: '/subscription/:orderId', name: 'Subscription', component: Subscription, props: true },
				{ path: '/churchs', name: 'Churchs', component: Churchs, meta: { menu_id: 29 } },
				{ path: '/profile', name: 'Profile', component: Profile },
				{ path: '/generatedSubscriptions', name: 'GeneratedSubscriptions', component: GeneratedSubscriptions, meta: { menu_id: 15 } },
				{ path: '/sales', name: 'Sales', component: Sales, meta: { menu_id: 8 } },
				{ path: '/orders', name: 'Orders', component: Orders, meta: { menu_id: 20 } },
				{ path: '/test', name: 'Test', component: Test, meta: { menu_id: 1 } },
				{ path: '/ticket/:idTicket', name: 'Ticket', component: Ticket, props: true, meta: { menu_id: 6 } },
				{ path: '/tickets', name: 'Tickets', component: Tickets, meta: { menu_id: 6 } },
				{ path: '/users', name: 'Users', component: Users, meta: { menu_id: 2 } },
				{ path: '/jumpsellerOrders', name: 'JumpsellerOrders', component: JumpsellerOrders, meta: {} },
				{ path: '/payments', name: 'Payments', component: Payments, meta: { menu_id: 24 } },
				{ path: '/inventoryRun', name: 'InventoryRun', component: InventoryRun, meta: {} },
				{ path: '/inventoryRun/:inventoryId', name: 'InventoryRunWithId', component: InventoryRun, props: true, meta: {} },
				{ path: '/assistantConfig', name: 'AssistantConfig', component: AssistantConfig, meta: { menu_id: 33 } },
				{ path: '/assistant/:id', name: 'AssistantEdit', component: AssistantEdit, props: true, meta: { menu_id: 33 } },
				{ path: '/assistant/:id/action/:actionId', name: 'AssistantActionEdit', component: AssistantActionEdit, props: true, meta: { menu_id: 33 } }
			]
		},
		{ path: '/bookstoreBilling', name: 'BookstoreBilling', component: BookstoreBilling, meta: { menu_id: 13 } },
		{ path: '/login', name: 'Login', component: Login },
		{ path: '/assistant', name: 'Assistant', component: Assistant },
		{ path: '/loading', name: 'Loading', component: Loading },
		{ path: '/logout', name: 'Logout', component: Logout },
		{ path: '/unauthorized', name: 'Unauthorized', component: Unauthorized },
		{ path: '*', redirect: '/' }
	]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

export default router
